// extracted by mini-css-extract-plugin
export var button = "style-module--button--b2d84";
export var dialog = "style-module--dialog--ac21c";
export var dialogBackdrop = "style-module--dialogBackdrop--0a9e8";